import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as mediaActions from '../store/media/actions';
import * as listsActions from '../store/lists/actions';
import * as reducers from '../store/reducers';
import { Bling as GPT } from 'react-gpt';

import ContentCollections from 'Containers/ContentCollections';
import VideoPlayer from 'Components/VideoPlayer';
import ContentHeader from 'Components/ContentHeader';
import ContentInfoBox from 'Components/ContentInfoBox';
import ContentTags from 'Components/ContentTags';
import ErrorPage from 'Screens/ErrorPage';
import Loading from 'Components/Loading';
import RampUnit from '../utils/Playwire/RampUnit';
import DocumentHeadFields from 'Components/DocumentHeadFields';

import { withLocationWrapper } from '../utils/HOC_LocationWrapper';

class VideoPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageLoading: true,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.slug !== prevProps.slug) {
      this.fetchData();
      this.setState({
        pageLoading: true,
      });
    }
    if (this.props.video && !prevProps.video && this.props.series) {
      this.setState({
        pageLoading: false,
      });
    }
    if (!this.props.isFetching && this.state.pageLoading) {
      this.setState({
        pageLoading: false,
      });
    }
  }

  fetchData() {
    const { slug, fetchMedia, fetchMediaLists, location } = this.props;
    fetchMedia(slug);
    const qs = { slug };
    fetchMediaLists('videoPermalink', location.pathname, qs);
  }

  render() {
    const { video, series, isFetching, errors, lists } = this.props;
    const { pageLoading } = this.state;

    if ((errors.media || errors.lists) && !video) {
      return (
        <ErrorPage
          errorCode="404"
          errorType="pageNotFound"
          errorMessage={errors.media.message}
        />
      );
    }
    if (pageLoading || !series) {
      return <Loading />;
    }
    const contentHeaderProps = {
      ...video,
      tagline:
        !video.tagline || video.tagline === '' ? series.tagline : video.tagline,
    };
    return (
      <main>
        {video && series && (
          <DocumentHeadFields mediaItem={video} mediaSeries={series} />
        )}

        <div className="Page__container Page__container--no-padding">
          <RampUnit type="leaderboard_atf" id="top" />
        </div>
        <div className="Page__ContentWrapper">
          <div className="Page__container Page__container--main">
            <section className="ContentBlock ContentBlock--content-canvas">
              <div className="ContentBlock__content">
                <ContentHeader {...contentHeaderProps} />
                <VideoPlayer video={video} series={series} />
                <div className="Page__item-details">
                  <ContentInfoBox
                    headline="Description"
                    body={video.description}
                    extraClass=" ContentInfoBox--VideoDescription"
                  />
                  {series ? (
                    <ContentInfoBox
                      headline={`About ${series.title}`}
                      body={series.description}
                      extraClass=" ContentInfoBox--VideoSeries"
                    />
                  ) : null}
                </div>
                {!isFetching ? <ContentCollections lists={lists} /> : null}
                <div className="Page__item-details">
                  <ContentTags {...video} />
                </div>
              </div>
            </section>
          </div>
          <aside className="ContentBlock__aside">
            <RampUnit type="med_rect_atf" id="siderec" />
            <RampUnit type="med_rect_btf" id="sideflex" />
          </aside>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, { params, location }) => {
  const slug = params.videoID;
  return {
    slug,
    isFetching: reducers.getIsPageFetching(state),
    video: reducers.getMediaItem(state, slug),
    lists: reducers.getMediaLists(state, 'videoPermalink', location.pathname),
    series: reducers.getMediaSeries(state, slug),
    errors: reducers.getErrors(state),
  };
};

const allActions = {
  ...mediaActions,
  ...listsActions,
};

const VideoPageComponent = connect(mapStateToProps, allActions)(VideoPage);

export default withLocationWrapper(VideoPageComponent);
